// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Dollar: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67 65"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M64.9 15.1H2.1c-.6 0-1 .4-1 1v32.8c0 .6.4 1 1 1h62.8c.6 0 1-.4 1-1V16.1c0-.6-.4-1-1-1zm-1.8 2.8v29.2H3.9V17.9h59.2z"/><path d="M6.1 40.9h.4c2 0 3.6 1.6 3.6 3.6v.4c0 .6.4 1 1 1h44.8c.6 0 1-.4 1-1v-.4c0-2 1.6-3.6 3.6-3.6h.4c.6 0 1-.4 1-1V25.1c0-.6-.4-1-1-1h-.4c-2 0-3.6-1.6-3.6-3.6v-.4c0-.6-.4-1-1-1H11.1c-.6 0-1 .4-1 1v.4c0 2-1.6 3.6-3.6 3.6h-.4c-.6 0-1 .4-1 1v14.8c0 .6.4 1 1 1zm1.8-2.6V26.7c2.4-.6 4.4-2.5 4.8-4.8h41.6c.5 2.5 2.4 4.4 4.8 4.8v11.6c-2.4.6-4.4 2.5-4.8 4.8H12.7c-.5-2.5-2.4-4.4-4.8-4.8z"/><path d="M33.5 41.9c5.2 0 9.4-4.2 9.4-9.4s-4.2-9.4-9.4-9.4-9.4 4.2-9.4 9.4 4.2 9.4 9.4 9.4zm0-16c3.6 0 6.6 3 6.6 6.6 0 3.6-3 6.6-6.6 6.6-3.6 0-6.6-3-6.6-6.6 0-3.6 3-6.6 6.6-6.6z"/></svg>;
};

export default React.memo(Dollar);
